import React from 'react'
const About = () => {
    return (
        <div id="about">
            <div className="header">
                <i className="fas fa-lightbulb fa-2x"></i>
                <span className="primary">About this App :</span>
            </div>
            <div className="info">
                <h2><i className="fas fa-dice-d20"></i>&nbsp;SJ Games</h2>
                <h1 className="secondary">Threat free online Gaming Platform where you can enjoy cool and amazing games for free and unlimited.</h1>
            </div>
        </div>
    )
}

export default About
